import type { FundingApplicationSchemas } from "@wayflyer/api-types";

export type Step =
  | "has_additional_platform"
  | "no_platform_reason"
  | "select_additional_source"
  | "connect_additional_source";

// We can't dynamitcally generate TS literal types at run time, so we have to manually define it
const noOtherConnectionsReasonCodes: FundingApplicationSchemas.NoOtherConnectionsReasonCode[] = [
  "store_decommissioned",
  "company_less_than_6m_old",
  "no_other_revenue_sources",
  "unsupported_store",
  "other",
];

export const isNoOtherConnectionsReasonCode = (value: string) => {
  return noOtherConnectionsReasonCodes.includes(value as FundingApplicationSchemas.NoOtherConnectionsReasonCode);
};
